import apiParent from '@/api/parent'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  deleteParentStart: '[delete parent] Delete parent start',
  deleteParentSuccess: '[delete parent] Delete parent success',
  deleteParentFailure: '[delete parent] Delete parent failure'
}

export const actionTypes = {
  deleteParent: '[delete parent] Delete parent'
}

const mutations = {
  [mutationTypes.deleteParentStart] (state) {
    state.isSubmitting = true
  },

  [mutationTypes.deleteParentSuccess] (state) {
    state.isSubmitting = false
  },

  [mutationTypes.deleteParentFailure] (state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.deleteParent] (context, { parentId, childId }) {
    context.commit(mutationTypes.deleteParentStart)
    return new Promise(resolve => {
      apiParent
        .deleteParent(parentId, childId)
        .then(response => {
          context.commit(mutationTypes.deleteParentSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.deleteParentFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
